import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import './ClientLogos.css';

// Import logos
import pmchLogo from '../assets/pmch.png';
import horizonLogo from '../assets/Horizon.png';
import anantaLogo from '../assets/ananta.png';
import bclLogo from '../assets/BCL_nobg.png';

const ClientLogos = () => {
  const clients = [
    {
      name: 'PMCH',
      fullName: 'Pacific Medical College & Hospital, Udaipur',
      logo: pmchLogo,
      color: '#51A8B1'
    },
    {
      name: 'HORIZON',
      fullName: 'Horizon Medical Consultants',
      logo: horizonLogo,
      color: '#A8CF45'
    },
    { 
      name: 'AIMS&RC', 
      fullName: 'Ananta Institute of Medical Sciences & Research Centre, Udaipur',
      logo: anantaLogo,
      color: '#51A8B1' 
    },
  ];

  return (
    <Box className="client-section">
      {/* BCL Watermark Logo */}
      <img 
        src={bclLogo} 
        alt="BCL Logo" 
        className="bcl-watermark"
      />

      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="h3"
            className="section-title"
          >
            Trusted By Leading Healthcare Institutions
          </Typography>
          <Typography
            variant="h6"
            className="section-subtitle"
          >
            Our solutions power some of India's most prestigious medical facilities
          </Typography>
        </motion.div>

        <Box className="clients-container">
          {clients.map((client, index) => (
            <motion.div
              key={index}
              className="client-card-wrapper"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true }}
            >
              <div 
                className="client-card"
                style={{
                  '--accent-color': client.color,
                }}
              >
                {/* Logo Container */}
                <div className="logo-container">
                  <img 
                    src={client.logo} 
                    alt={client.name}
                    className="client-logo"
                  />
                </div>

                {/* Content */}
                <div className="card-content">
                  <h4 className="client-name" style={{ color: client.color }}>
                    {client.name}
                  </h4>
                  <p className="client-fullname">
                    {client.fullName}
                  </p>
                </div>

                {/* Decorative Elements */}
                <div className="corner-accent"></div>
                <div className="hover-overlay"></div>
              </div>
            </motion.div>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default ClientLogos;